import type { API } from 'api/config/types';
import { Core } from 'chessboard/core/config/types';
import { calculateTimestampValue } from 'chessboard/model/move/calculate-timestamp-value';

/**
 * Create the set times method for the times API
 */
export function createSetTimes(context) {
  /**
   * Set a time (move time taken) property on a move node, as well as a timestamp
   */
  return function set(time: number, index: number): API.Response | null {
    const { api, respond } = context;
    const { getLine } = api;

    const node = getLine(0)?.[index];

    if (!node) {
      return null;
    }

    if (!node.time) {
      node.time = time;
    }

    api.timestamps.set(calculateTimestampValue({ api, node }), index);

    return respond(Core.APIEvents.NodeUpdated, { changes: { time, node } });
  };
}
